import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    },
    title: {
        color: '#fff',
    },
    wrap: {
        display: 'flex', 
        flexDirection: 'column',
        width: '100%'
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
    wrapTable: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    flex: {
        display: 'flex'
    },
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'visible',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'visible',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%',
    }
}));

export {
    useStyles
}